jQuery(document).ready(function ($) {
  var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 100);
    }
  };
  var wishlistAdded = false;
  waitForEl(".product--button-wishlist", function () {
    setTimeout(function () {
      if ($(".product--button-wishlist").hasClass("swym-added"))
        wishlistAdded = true;
    }, 1000);
  });
  $(".product--button-wishlist").click(function (e) {
    onRemoveBtnClick(e);
    if (wishlistAdded) {
      var productPath = $(this).data("product-url");
      var parentEl = $(this).parents(".product--detail-wishlist");
      var vendorName = capitalizeFirstLetter(
        parentEl.find(".vendor--name").text()
      );
      var itemLink = "/collections/all/?filter.p.vendor=" + vendorName;
      toggleActiveClass(vendorName, itemLink, productPath);
      wishlistAdded = false;
    } else {
      var productPath = $(this).data("product-url");
      var parentEl = $(this).parents(".product--detail-wishlist");
      var vendorName = capitalizeFirstLetter(
        parentEl.find(".vendor--name").text()
      );
      var itemLink = "/collections/all/?filter.p.vendor=" + vendorName;
      toggleActiveClass(vendorName, itemLink, productPath);
      wishlistAdded = true;
    }
    setTimeout(function () {
      window.SwymCallbacks.push(swymRenderWishlist);
    }, 1000);
  });

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function toggleActiveClass(itemName, itemLink, productPath) {
    var dataFavouritesDesign =
      JSON.parse(localStorage.getItem("dataFavouritesDesign")) || [];
    var itemIndex = dataFavouritesDesign.findIndex(function (item) {
      return item.name === itemName && item.link === itemLink;
    });

    if (itemIndex === -1) {
      dataFavouritesDesign.push({
        name: itemName,
        link: itemLink,
        list: [productPath],
      });
    } else {
      var productIndex =
        dataFavouritesDesign[itemIndex].list.indexOf(productPath);
      if (productIndex === -1) {
        dataFavouritesDesign[itemIndex].list.push(productPath);
      } else {
        dataFavouritesDesign[itemIndex].list.splice(productIndex, 1);

        if (dataFavouritesDesign[itemIndex].list.length === 0) {
          dataFavouritesDesign.splice(itemIndex, 1);
        }
      }
    }

    // Save the updated array back to local storage.
    localStorage.setItem(
      "dataFavouritesDesign",
      JSON.stringify(dataFavouritesDesign)
    );
  }
});

/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid">
	{{#products}} 
		<x-grid columns="12" class="productsInCart">
			<x-cell class="image" span="3" rv-show="item.image">
				<a href="{{du}}"><img alt="" class="swym-wishlist-image" src="{{iu}}"></a>
			</x-cell>
			<x-cell class="name" span="9">
				<a href="{{du}}">
					{{dt}}
				</a>
				<span class="variant-title">{{variantinfo}}</span>
				<div class="item-price">
					<div>
						<span class="price"><span class="currency-symbol">$</span>{{pr}}</span>
      <a href="{{du}}"><button class="button">
       {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
     </button></a>
					</div>
				</div>
			</x-cell>
			<x-cell span="1" style="padding:0">
				<x-flex ai="center" jc="around" jc-s="between" wrap="wrap" class="controllers" style="gap:0 1rem">
					<x-cell>
						<button id="" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-remove-productBtn is-blank swym-delete-btn swym-nav swym-nav-1 swym-is-button">
							<span class="times remove">
								<i class="g-trash"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5488 16.5312L13.0176 12L17.5488 7.4688C17.6856 7.332 17.76 7.152 17.76 6.96C17.76 6.768 17.6856 6.588 17.5488 6.4512C17.268 6.1704 16.812 6.1704 16.5312 6.4512L12 10.9824L7.46879 6.4512C7.18799 6.1704 6.73199 6.1704 6.45119 6.4512C6.31439 6.588 6.23999 6.768 6.23999 6.96C6.23999 7.152 6.31439 7.332 6.45119 7.4688L10.9824 12L6.45119 16.5312C6.31439 16.668 6.23999 16.848 6.23999 17.04C6.23999 17.232 6.31439 17.412 6.45119 17.5488C6.72239 17.82 7.19759 17.82 7.46879 17.5488L12 13.0176L16.5312 17.5488C16.8024 17.82 17.2776 17.82 17.5488 17.5488C17.6856 17.412 17.76 17.232 17.76 17.04C17.76 16.848 17.6856 16.668 17.5488 16.5312Z" fill="currentColor"/></svg></i>
							</span>
						</button>
					</x-cell>
				</x-flex>
			</x-cell>
		</x-grid>
	{{/products}}
</div>`;

var productCardPageWishlist = `<div class="products">
	<div class="product">
		<x-grid class="cards" columns="3" columns-m="2" columns-s="1" card-type="base" card-ratio="portrait" card-quickbuy="true" card-quickbuy-hover="true" card-quickbuy-float="false" card-img-crop="wide" card-img-radius="false" card-img-padding="false">
			{{#products}} 
				<x-cell class="item" {{ hscrollElement }} prod-instock="{{ product.available }}">
					<div class="card-image">
						<a href="{{du}}" {{ collectionAwareUrl }} class="no-style" tabindex="-1">
							<div class="card-aspect-ratio"></div>
							<div class="primary">
								<picture>
									<img alt="" class="swym-wishlist-image" src="{{iu}}">
								</picture>
							</div>
							
							<div class="label-wraper">
							</div>
							
						</a>
						<button id="" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-remove-productBtn is-blank swym-delete-btn swym-nav swym-nav-1 swym-is-button">
							<span class="times remove">
								<i class="g-trash"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5488 16.5312L13.0176 12L17.5488 7.4688C17.6856 7.332 17.76 7.152 17.76 6.96C17.76 6.768 17.6856 6.588 17.5488 6.4512C17.268 6.1704 16.812 6.1704 16.5312 6.4512L12 10.9824L7.46879 6.4512C7.18799 6.1704 6.73199 6.1704 6.45119 6.4512C6.31439 6.588 6.23999 6.768 6.23999 6.96C6.23999 7.152 6.31439 7.332 6.45119 7.4688L10.9824 12L6.45119 16.5312C6.31439 16.668 6.23999 16.848 6.23999 17.04C6.23999 17.232 6.31439 17.412 6.45119 17.5488C6.72239 17.82 7.19759 17.82 7.46879 17.5488L12 13.0176L16.5312 17.5488C16.8024 17.82 17.2776 17.82 17.5488 17.5488C17.6856 17.412 17.76 17.232 17.76 17.04C17.76 16.848 17.6856 16.668 17.5488 16.5312Z" fill="currentColor"/></svg></i>
							</span>
						</button>
					</div>
					<div class="card-meta">
						<div class="card-row">
							<div class="card-column-left">
								<h2 class="card-title h4"><a href="{{du}}" {{ collectionAwareUrl }} class="no-style">{{dt}}</a></h2>
							</div>
							<div class="card-column-right">
								<div class="card-price">
									<div>
										<span class="price"><span class="currency-symbol">$</span>{{pr}}</span>
									</div>
								</div>
							</div>
						</div>	
					</div>
				</x-cell>
			{{/products}}
		</x-grid>
	</div>
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
      variants && variants != "[]"
        ? Object.keys(JSON.parse(variants)[0])
        : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = "Added to Cart";
      e.target.setAttribute("data-state-cart", "swym-added");
      console.log("Successfully added product to cart.", c);
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function swymRenderWishlist(swat) {
  //console.log(swat);
  // Get wishlist items
  swat.fetch(function (products) {
    var wishlistPageContainer = document.getElementById(
      "wishlist-page-container"
    );
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map(function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    var productCardsPageWishlist = SwymUtils.renderTemplateString(
      productCardPageWishlist,
      {
        products: formattedWishlistedProducts,
      }
    );
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
    if (wishlistPageContainer) {
      wishlistPageContainer.innerHTML = productCardsPageWishlist;
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
    if (jQuery(".swym-wishlist-bag").length > 0) {
      document.querySelector(".swym-wishlist-bag").textContent =
        formattedWishlistedProducts.length;
    }
    if (jQuery(".wishlist-count").length > 0) {
      document.querySelector(".wishlist-count").textContent =
        formattedWishlistedProducts.length;
    }
    if (formattedWishlistedProducts.length > 1) {
      jQuery(".wishlist-items").removeClass("hidden");
      jQuery(".wishlist-item").addClass("hidden");
    } else {
      jQuery(".wishlist-items").addClass("hidden");
      jQuery(".wishlist-item").removeClass("hidden");
    }
    if (formattedWishlistedProducts.length == 0) {
      jQuery("#wishlist-page-container").addClass("hidden");
      jQuery("#wishlist-page-container")
        .parent(".listing-page")
        .addClass("wishlist-no-items");
    } else {
      jQuery("#wishlist-page-container")
        .parent(".listing-page")
        .removeClass("wishlist-no-items");
      jQuery("#wishlist-page-container").removeClass("hidden");
    }
    if (products.length > 0) {
      jQuery(".swym-wishlist").addClass("swym-wishlist-active");
    } else {
      jQuery(".swym-wishlist").removeClass("swym-wishlist-active");
    }
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll(".swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
  // console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
